import { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiExternalLink, FiFlag, FiCheckCircle, FiInfo, FiEye } = FiIcons;

const guides = {
  Facebook: 'Open the post menu and choose Find support or report post.',
  Instagram: 'Tap the post menu, choose Report, then select the reason that fits.',
  TikTok: 'Press and hold the video, choose Report, and follow the prompts.',
  X: 'Open the post menu, choose Report post, and complete the steps.',
  YouTube: 'Use the More menu below the video or comment and select Report.',
  WhatsApp: 'Open the chat or profile options and choose Report.',
  Other: 'Use the platform’s official safety or reporting tools.'
};

function FeedPage({ cases, onReport, onFlag, notify, onNavigate }) {
  const [flagged, setFlagged] = useState([]);
  const [reported, setReported] = useState([]);

  const flag = async (item) => {
    if (flagged.includes(item.id)) return notify('You have already flagged this case.');
    await onFlag(item);
    setFlagged((current) => [...current, item.id]);
  };

  const report = async (item) => {
    if (reported.includes(item.id)) return notify('You have already reported this case.');
    await onReport(item);
    setReported((current) => [...current, item.id]);
  };

  return (
    <section>
      <div className="page-intro feed-intro">
        <span className="eyebrow">Community cases</span>
        <h1>Community feed</h1>
        <p>
          Cases appear here after submission. Report through the platform’s own tools—never engage or retaliate.
        </p>
      </div>
      <div className="safety-strip">
        <SafeIcon icon={FiInfo} />
        <span>
          <b>Report only.</b> No commenting, threats, or retaliation. Report totals are community confirmations and are not independently verified.
        </span>
      </div>
      <div className="case-list">
        {cases.map((item) => (
          <article className="feed-card" key={item.id}>
            <div className="feed-card-head">
              <div className="platform-avatar">{item.platform.slice(0, 1)}</div>
              <div className="feed-title">
                <span className="category-tag">{item.category}</span>
                <h2>{item.platform} post</h2>
                <small>
                  {item.date} · {Number(item.views || 0)} views · {item.reports || 0} reports
                </small>
              </div>
              <button
                className="flag-button"
                onClick={() => flag(item)}
                aria-label="Flag this case"
              >
                <SafeIcon icon={FiFlag} /> Flag
              </button>
            </div>
            <p className="case-description">{item.description}</p>
            <div className="howto">
              <b>How to report on {item.platform}</b>
              <p>{guides[item.platform] || guides.Other}</p>
            </div>
            <div className="feed-actions">
              <button className="button button-secondary" onClick={() => onNavigate(item.id)}>
                <SafeIcon icon={FiEye} /> View case
              </button>
              <a className="button button-secondary" href={item.link} target="_blank" rel="noreferrer">
                Open post <SafeIcon icon={FiExternalLink} />
              </a>
              <button className="button button-primary" onClick={() => report(item)}>
                <SafeIcon icon={FiCheckCircle} /> I Reported This
              </button>
            </div>
            {reported.includes(item.id) && (
              <small className="pending-caption">
                Your confirmation is recorded; reports are not independently verified.
              </small>
            )}
          </article>
        ))}
        {cases.length === 0 && (
          <div className="empty-state">No cases have been submitted yet.</div>
        )}
      </div>
    </section>
  );
}

export default FeedPage;